import React from 'react'
import styled from 'styled-components'
import { Sanitizer } from 'live/services/sanitizer'

type IconConfig = {
    icon: string
    size?: number
    color?: string
    background?: string
    style?: React.CSSProperties
}
interface HeaderItemProps {
    content?: {
        title?: string
        value?: string
        style?: React.CSSProperties
    }
    iconConfig?: IconConfig
    children?: React.ReactNode
}
export const HeaderItem = (props: HeaderItemProps): JSX.Element => {
    const { iconConfig, content, children } = props

    return (
        <HeaderItemStyledContainer>
            <IconContainer
                icon={iconConfig?.icon}
                background={iconConfig?.background}
                size={iconConfig?.size}
                color={iconConfig?.color}
                style={iconConfig?.style || {}}
            >
                {iconConfig?.icon && <i className={iconConfig.icon}></i>}
            </IconContainer>

            {content?.title ? (
                <Sanitizer html={content?.title}>
                    {sanitized => (
                        <StyledValue
                            style={content?.style || {}}
                            dangerouslySetInnerHTML={{
                                __html: sanitized
                            }}
                        />
                    )}
                </Sanitizer>
            ) : (
                <StyledValue style={content?.style || {}}>{children}</StyledValue>
            )}
        </HeaderItemStyledContainer>
    )
}

const StyledValue = styled.span`
    font-size: 16px;
    font-weight: 600;
    color: var(--gray-600);
`

const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    font-size: ${({ size }) => (size ? `${size}px` : '20px')};
    color: ${({ color }) => color || 'var(--blue-700)'};
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    ${({ background }) =>
        background
            ? `
        background: ${background};
        width: 40px;
        height: 40px;
    `
            : `
        
        width: 20px;
        height: 20px;
    `}
    ${({ icon }) => icon && `margin-right: 8px;`}
`
const HeaderItemStyledContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`
